export class CamposGenericos {
    autor: string;
    codigo: number;
    displayValue:string;
    fechaCreacion: Date;
    habilitacion: boolean;
}